var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8335 10C1.8335 5.02944 5.86293 1 10.8335 1C15.8041 1 19.8335 5.02944 19.8335 10C19.8335 14.9706 15.8041 19 10.8335 19C5.86293 19 1.8335 14.9706 1.8335 10Z",
    stroke: "#616874",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4585 7.89062C7.4585 7.19164 8.02514 6.625 8.72412 6.625H12.9429C13.6419 6.625 14.2085 7.19164 14.2085 7.89062V12.1094C14.2085 12.8084 13.6419 13.375 12.9429 13.375H8.72412C8.02514 13.375 7.4585 12.8084 7.4585 12.1094V7.89062Z",
    stroke: "#616874",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/Draft.8aae6dd7b2915b8095c027e011df152e.svg";
export { ForwardRef as ReactComponent };